import React from 'react';
import { observer } from 'mobx-react';

import './mail-ordered-prescription-fill-style.scss';


const MailOrderedVideoConferenceNotification = ({ prescriptionFill }) => (
  <div key={prescriptionFill.id} className='c-MailOrderedPrescriptionFillNotification'>
    <div className='patient-name'>
      {`${prescriptionFill.prescription.patient.firstName} ${prescriptionFill.prescription.patient.lastName}`}
    </div>
    <div className='drug-name'>
      {`${prescriptionFill.prescription.drug.name}`}
    </div>
  </div>
);

export default observer(MailOrderedVideoConferenceNotification);
